// Integration types
export var GOOGLE_ANALYTICS_TO_SPLIT = 'GOOGLE_ANALYTICS_TO_SPLIT';
export var SPLIT_TO_GOOGLE_ANALYTICS = 'SPLIT_TO_GOOGLE_ANALYTICS';
// This value might be eventually set via a config parameter
export var DEFAULT_CACHE_EXPIRATION_IN_MILLIS = 864000000; // 10 days



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/utils/constants/browser.js
// module id = 1313
// module chunks = 25